import { render, staticRenderFns } from "./TelegramGroupHelp.vue?vue&type=template&id=d126c5c6&scoped=true&"
import script from "./TelegramGroupHelp.vue?vue&type=script&lang=js&"
export * from "./TelegramGroupHelp.vue?vue&type=script&lang=js&"
import style0 from "./TelegramGroupHelp.vue?vue&type=style&index=0&id=d126c5c6&scoped=true&lang=css&"
import style1 from "./TelegramGroupHelp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d126c5c6",
  null
  
)

export default component.exports